import { CellAction } from "./cell-action";

import { Slider } from "@/src/data/types";
import { ColumnDef } from "@tanstack/react-table";
const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

export const columns: ColumnDef<Slider>[] = [
  {
    accessorKey: "image",
    header: "IMAGE",
    cell: ({ row }) => (
      <img
        src={`${uploadUrl}/team/${row.original.image}`}
        alt={`Image for ${row.original.image}`}
        className="w-16 rounded-lg h-14"
      />
    ),
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
